export default (trackerStep, trackerArea) => {
  if (typeof window.cact === "function") {
    window.cact("emit", "tracker_microbiota", {
      tracker_step: trackerStep,
      tracker_area: trackerArea,
    });
  }
};
